import { render, staticRenderFns } from "./yingFuDetil.vue?vue&type=template&id=71231e90&scoped=true&"
import script from "./yingFuDetil.vue?vue&type=script&lang=js&"
export * from "./yingFuDetil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71231e90",
  null
  
)

export default component.exports